module.exports = __webpack_public_path__ + "static/media/AI.417419b9.svg";